<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M8.88889 10.2765C8.88889 9.66426 9.38777 9.16537 10 9.16537C10.6122 9.16537 11.1111 9.66426 11.1111 10.2765C11.1111 10.8887 10.6122 11.3876 10 11.3876C9.38777 11.3876 8.88889 10.8887 8.88889 10.2765Z"
            fill="currentColor"
        />
        <path
            d="M13.8889 11.3876C14.5011 11.3876 15 10.8887 15 10.2765C15 9.66426 14.5011 9.16537 13.8889 9.16537C13.2767 9.16537 12.7778 9.66426 12.7778 10.2765C12.7778 10.8887 13.2767 11.3876 13.8889 11.3876Z"
            fill="currentColor"
        />
        <path
            d="M8.88889 13.6098C8.88889 12.9976 9.38777 12.4987 10 12.4987C10.6122 12.4987 11.1111 12.9976 11.1111 13.6098C11.1111 14.222 10.6122 14.7209 10 14.7209C9.38777 14.7209 8.88889 14.222 8.88889 13.6098Z"
            fill="currentColor"
        />
        <path
            d="M6.11111 12.4987C5.49889 12.4987 5 12.9976 5 13.6098C5 14.222 5.49889 14.7209 6.11111 14.7209C6.72333 14.7209 7.22222 14.222 7.22222 13.6098C7.22222 12.9976 6.72333 12.4987 6.11111 12.4987Z"
            fill="currentColor"
        />
        <path
            d="M12.7778 13.6098C12.7778 12.9976 13.2767 12.4987 13.8889 12.4987C14.5011 12.4987 15 12.9976 15 13.6098C15 14.222 14.5011 14.7209 13.8889 14.7209C13.2767 14.7209 12.7778 14.222 12.7778 13.6098Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.38889 0.0820312C6.8031 0.0820312 7.13889 0.417818 7.13889 0.832031V2.30426H12.8611V0.832031C12.8611 0.417818 13.1969 0.0820312 13.6111 0.0820312C14.0253 0.0820312 14.3611 0.417818 14.3611 0.832031V2.30426H15.2778C16.9193 2.30426 18.25 3.63497 18.25 5.27648V14.7209C18.25 16.3624 16.9193 17.6931 15.2778 17.6931H4.72222C3.08071 17.6931 1.75 16.3624 1.75 14.7209V5.27648C1.75 3.63497 3.08071 2.30426 4.72222 2.30426H5.63889V0.832031C5.63889 0.417818 5.97467 0.0820312 6.38889 0.0820312ZM16.75 5.27648V6.19315H3.25V5.27648C3.25 4.4634 3.90914 3.80426 4.72222 3.80426H15.2778C16.0909 3.80426 16.75 4.4634 16.75 5.27648ZM16.75 7.69315H3.25V14.7209C3.25 15.534 3.90914 16.1931 4.72222 16.1931H15.2778C16.0909 16.1931 16.75 15.534 16.75 14.7209V7.69315Z"
            fill="currentColor"
        />
    </svg>
</template>
